/**
 * checks if all the features the application needs are available.
 * @returns {boolean} - true if the necessary features are available
 */
export const featureCheck = () => {
    // for now just check for webgl support
    return checkWebGLSupport();
};

const supportCache = window;

export function checkWebGLSupport() {
    if (supportCache.hasOwnProperty('hasWebGLSupport')) return supportCache.hasWebGLSupport;
    try {
        const canvas = document.createElement('canvas');
        supportCache.hasWebGLSupport =
            !!window.WebGLRenderingContext && (canvas.getContext('webgl2') || canvas.getContext('experimental-webgl'));
    } catch (e) {
        supportCache.hasWebGLSupport = false;
    }
    return supportCache.hasWebGLSupport;
}
